export default __webpack_public_path__ + "static/media/whatsapp.ea0277ca.svg";